import { create } from 'zustand';

export type TypeIsLoading = boolean | { dimmed: boolean };

type TypeLoadingStore = {
  loadingCount: number;
  dimmed: boolean;
  startLoading: (options?: { dimmed?: boolean }) => void;
  endLoading: () => void;
  /** @TODO React Query 전체 전환 후 제거 */
  isLoading: TypeIsLoading;
  /** @TODO React Query 전체 전환 후 제거 */
  setIsLoading: (isLoading: TypeIsLoading) => void;
};

export const useLoadingStore = create<TypeLoadingStore>((set, get) => ({
  loadingCount: 0,
  dimmed: true,
  /** @TODO React Query 전체 전환 후 제거 */
  isLoading: false,
  startLoading: (options) =>
    set((state) => ({
      loadingCount: state.loadingCount + 1,
      isLoading: true,
      // 첫 번째 로딩일 때만 dimmed 설정, 이후 로딩은 기존 설정 유지
      dimmed: state.loadingCount === 0 ? (options?.dimmed ?? true) : state.dimmed,
    })),
  endLoading: () =>
    set((state) => {
      const newCount = Math.max(0, state.loadingCount - 1);
      return {
        loadingCount: newCount,
        isLoading: newCount > 0,
        // 모든 로딩 완료 시 기본값으로 초기화
        dimmed: newCount === 0 ? true : state.dimmed,
      };
    }),
  /** @TODO React Query 전체 전환 후 제거 */
  setIsLoading: (isLoading) => {
    if (isLoading === false) {
      get().endLoading();
    } else if (isLoading === true) {
      get().startLoading();
    } else if (typeof isLoading === 'object') {
      get().startLoading({ dimmed: isLoading.dimmed });
    }
  },
}));
